'use client';
import React, { useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const testimonials = [
{
  id: 'review-001',
  name: 'Priya & Arjun Mehta',
  event: 'Wedding Reception',
  venue: 'The Grand Meridian, Mumbai',
  rating: 5,
  avatar: "https://images.unsplash.com/photo-1729101143873-d80050bae219",
  avatarAlt: 'Smiling Indian woman with long dark hair in red saree',
  text: 'Festaa made our wedding planning so effortless. We found The Grand Meridian in under 10 minutes, checked availability instantly, and the advance booking process was seamless. Our 650 guests were absolutely wowed.',
  date: 'March 2026'
},
{
  id: 'review-002',
  name: 'Rahul Sharma',
  event: 'Annual Corporate Conference',
  venue: 'Skyline Terrace, Delhi',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_12c863552-1763294002377.png",
  avatarAlt: 'Professional Indian man in blue business shirt with confident smile',
  text: 'As a corporate event manager, I need reliability above all else. Festaa delivered — real photos, accurate capacity info, and the venue was exactly as described. Booked 3 more events through Festaa since.',
  date: 'February 2026'
},
{
  id: 'review-003',
  name: 'Sneha Kapoor',
  event: 'Birthday Celebration',
  venue: 'The Blue Lagoon, Pune',
  rating: 5,
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1835ca699-1763300783888.png",
  avatarAlt: 'Young Indian woman smiling with shoulder-length hair and casual top',
  text: 'Planned my sister\'s 30th birthday in 2 days! The filter by budget and capacity made it super easy to find something perfect. The venue team was already briefed before we arrived. Absolutely loved it.',
  date: 'January 2026'
},
{
  id: 'review-004',
  name: 'Vikram & Deepika Nair',
  event: 'Wedding Ceremony',
  venue: 'Heritage Haveli, Jaipur',
  rating: 5,
  avatar: "https://images.unsplash.com/photo-1573951648026-fa38ff3f6770",
  avatarAlt: 'Couple smiling together in traditional Indian wedding attire',
  text: 'We wanted a heritage venue for our Rajasthani-theme wedding. Found Heritage Haveli on Festaa, the photos were stunning and accurate. 900 guests, zero hiccups. The online payment was instant and secure.',
  date: 'December 2025'
}];


export default function TestimonialsSection() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((a) => a === 0 ? testimonials?.length - 1 : a - 1);
  const next = () => setActive((a) => a === testimonials?.length - 1 ? 0 : a + 1);

  const t = testimonials?.[active];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="section-title">What Our Customers Say</h2>
          <p className="section-subtitle">Real stories from real event hosts</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-br from-red-50 to-white rounded-3xl p-8 md:p-12 shadow-card relative">
            <Quote size={48} className="text-red-100 absolute top-6 left-6" />

            <div className="relative z-10">
              <div className="flex items-center gap-1 mb-6">
                {Array.from({ length: 5 })?.map((_, i) =>
                <Star key={`star-${active}-${i}`} size={18} className="fill-yellow-400 text-yellow-400" />
                )}
              </div>

              <p className="text-gray-700 text-lg leading-relaxed mb-8 font-medium">
                &ldquo;{t?.text}&rdquo;
              </p>

              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden ring-2 ring-red-100">
                    <AppImage src={t?.avatar} alt={t?.avatarAlt} width={56} height={56} className="object-cover w-full h-full" />
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">{t?.name}</div>
                    <div className="text-sm text-gray-500">{t?.event}</div>
                    <div className="text-xs text-red-500 font-medium">{t?.venue}</div>
                  </div>
                </div>
                <div className="text-gray-400 text-sm">{t?.date}</div>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border-2 border-gray-200 hover:border-red-500 hover:text-red-600 flex items-center justify-center transition-colors"
              aria-label="Previous testimonial">
              
              <ChevronLeft size={18} />
            </button>

            <div className="flex gap-2">
              {testimonials?.map((_, i) =>
              <button
                key={`dot-${i}`}
                onClick={() => setActive(i)}
                className={`rounded-full transition-all ${
                i === active ? 'w-6 h-2.5 bg-red-600' : 'w-2.5 h-2.5 bg-gray-200 hover:bg-red-300'}`
                }
                aria-label={`Go to testimonial ${i + 1}`} />

              )}
            </div>

            <button
              onClick={next}
              className="w-10 h-10 rounded-full border-2 border-gray-200 hover:border-red-500 hover:text-red-600 flex items-center justify-center transition-colors"
              aria-label="Next testimonial">
              
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>);

}